import fileaxiosInstance from "api/fileAxiosInstance"
import SAlert from "components/Alert"
import { batch } from "react-redux"
import { providerInAction } from "./provider-in-slice"
import axiosInstance from "api/axiosInstance"

// Get Provider In
export const getProviderIns =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null,
    advancedSearch = {}
  ) =>
  dispatch => {
    dispatch(providerInAction.setLoading(true))
    url = url || "/v1/provider-ins"
    fileaxiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then(response => {
        if (response) {
          batch(() => {
            dispatch(providerInAction.setError(null))
            dispatch(providerInAction.setData(response.data))
            dispatch(providerInAction.setLoading(false))
          })
        }
      })
      .catch(error => {
        dispatch(providerInAction.setLoading(false))
        console.log(error)
      })
  }

// Delete Multi Provider In
export const deleteManyProviderIn = ids => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .post("/v1/provider-ins/delete/ins", { ids })
    .then(response => {
      dispatch(getProviderIns())
      SAlert({ title: "Success", text: "Receipts successfully delete" })
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      if (error?.response?.data?.deleteError) {
        SAlert({
          text: error?.response?.data?.deleteError,
          status: "warning",
          timer: 5000,
        })
      }
      console.log(error)
    })
}

// Upload File For Multi Receipts
export const uploadFileForManyReceipts = forms => dispatch => {
  dispatch(
    providerInAction.setUploadFile({
      loading: true,
      error: null,
    })
  )
  fileaxiosInstance
    .post("/v1/provider-ins/upload/file-receipts", forms)
    .then(response => {
      dispatch(getProviderIns())
      dispatch(
        providerInAction.setUploadFile({
          loading: false,
          error: null,
        })
      )
      SAlert({ title: "Success", text: "File Successfully uploaded" })
    })
    .catch(error => {
      dispatch(
        providerInAction.setUploadFile({
          loading: false,
          error: null,
        })
      )
      if (error.response?.data?.errors?.document?.[0]) {
        SAlert({
          text: error.response?.data?.errors?.document?.[0],
          status: "warning",
          timer: 4000,
        })
      }
    })
}

// Delete Provider In
export const deleteProviderIn = id => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .delete(`/v1/provider-ins/${id}`)
    .then(response => {
      console.log(response?.data)
      dispatch(getProviderIns())
      SAlert({ title: "Success", text: "Receipt successfully delete" })
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      if (error?.response?.data?.deleteError) {
        SAlert({
          text: error?.response?.data?.deleteError,
          status: "warning",
          timer: 5000,
        })
      }
      console.log(error)
    })
}

// Store Provider In
export const storeProviderIn = (forms, navigate) => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .post(`/v1/provider-ins`, forms)
    .then(response => {
      navigate("/provider-receipts")
      SAlert({ title: "Success", text: "Receipt successfully inserted" })
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      console.log("error from provider in")
      dispatch(providerInAction.setLoading(false))
      if (error?.response?.data?.errors) {
        dispatch(providerInAction.setError(error?.response?.data?.errors))
      } else {
        SAlert({ title: "Success", text: "Receipt successfully inserted" })
      }
    })
}

// Store single draft
export const storeProviderInDraft = (forms, callback) => dispatch => {
  dispatch(providerInAction.setLoading(true))

  fileaxiosInstance
    .post(`/v1/provider-ins-draft`, forms)
    .then(response => {
      SAlert({ title: "Success", text: "Draft saved successfully" })
      // FIX: Refresh drafts list after successful save

      dispatch(getProviderInDrafts())

      dispatch(providerInAction.setLoading(false))
      if (callback) callback(true)
    })
    .catch(error => {
      console.log("Error saving draft:", error.response?.data)
      dispatch(providerInAction.setLoading(false))
      if (error?.response?.data?.errors) {
        dispatch(providerInAction.setError(error?.response?.data?.errors))
      } else {
        SAlert({
          title: "Error",
          text: error.response?.data?.message || "Failed to save draft",
        })
      }
      if (callback) callback(false)
    })
}

export const getProviderInDrafts = () => dispatch => {
  dispatch(providerInAction.setDraftsLoading(true))
  axiosInstance
    .get(`/v1/provider-ins-draft`)
    .then(response => {
      dispatch(providerInAction.setDrafts(response.data.data))
      dispatch(providerInAction.setDraftsLoading(false))
    })
    .catch(error => {
      dispatch(providerInAction.setDraftsError(error.message))
      dispatch(providerInAction.setDraftsLoading(false))
    })
}

// Update drafts to submitted status
export const updateDraftsToSubmitted = navigate => dispatch => {
  dispatch(providerInAction.setLoading(true))
  axiosInstance
    .patch(`/v1/provider-ins-update-drafts-status`, { status: "submitted" })
    .then(response => {
      // Clear drafts from state after successful submission
      dispatch(providerInAction.setDrafts([]))
      navigate("/provider-receipts")
      SAlert({ title: "Success", text: "All drafts submitted successfully" })
      dispatch(providerInAction.setLoading(false))
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      SAlert({ title: "Error", text: "Failed to submit drafts" })
    })
}

export const deleteProviderInDraft = id => dispatch => {
  dispatch(providerInAction.setLoading(true))
  console.log(id)
  fileaxiosInstance
    .delete(`/v1/provider-ins-draft/${id}`)
    .then(response => {
      dispatch(getProviderInDrafts())
      SAlert({ title: "Success", text: "Draft successfully delete" })
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      if (error?.response?.data?.deleteError) {
        SAlert({
          text: error?.response?.data?.deleteError,
          status: "warning",
          timer: 5000,
        })
      }
    })
}

// Delete multiple drafts
export const deleteManyProviderInDrafts = ids => dispatch => {
  dispatch(providerInAction.setLoading(true))
  axiosInstance
    .post("/v1/provider-ins-draft/delete/multiple", { ids })
    .then(response => {
      SAlert({ title: "Success", text: "Drafts deleted successfully" })
      dispatch(getProviderInDrafts()) // Refresh drafts list
      dispatch(providerInAction.setLoading(false))
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      if (error?.response?.data?.deleteError) {
        SAlert({
          text: error?.response?.data?.deleteError,
          status: "warning",
          timer: 5000,
        })
      } else {
        SAlert({ title: "Error", text: "Failed to delete drafts" })
      }
      console.error("Error deleting drafts:", error)
    })
}

export const updateProviderInDraft = (id, form, navigate) => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .post(`/v1/provider-ins-draft/${id}`, form)
    .then(response => {
      navigate("/add-provider-receipts")
      SAlert({ title: "Success", text: "Receipt successfully updated" })
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      if (error?.response?.data?.errors) {
        dispatch(providerInAction.setError(error?.response?.data?.errors))
      } else {
        console.log(error?.response)
      }
    })
}

// Update Provider In
export const updateProviderIn = (id, form, navigate) => dispatch => {
  dispatch(providerInAction.setLoading(true))
  console.log(form)
  fileaxiosInstance
    .post(`/v1/provider-ins/${id}`, form)
    .then(response => {
      navigate("/provider-receipts")
      SAlert({ title: "Success", text: "Receipt successfully updated" })
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      if (error?.response?.data?.errors) {
        dispatch(providerInAction.setError(error?.response?.data?.errors))
      } else {
        console.log(error?.response)
      }
    })
}

// Get Provider In By ID
export const getByIdProviderIn = id => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .get(`/v1/provider-ins/${id}`)
    .then(response => {
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setProviderIn(response?.data))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      console.log(error)
    })
}

export const getByIdProviderInDraft = id => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .get(`/v1/provider-ins-draft/${id}`)
    .then(response => {
      batch(() => {
        dispatch(providerInAction.setError(null))
        dispatch(providerInAction.setProviderIn(response?.data))
        dispatch(providerInAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      console.log(error)
    })
}

// Get Provider In Available Items
export const getProviderInAvailableItems =
  (params = {}) =>
  dispatch => {
    dispatch(
      providerInAction.setItems({
        loading: true,
        error: null,
        data: [],
      })
    )
    axiosInstance
      .get(`/v1/get-provider-in-items`, { params })
      .then(respnose => {
        dispatch(
          providerInAction.setItems({
            loading: false,
            error: null,
            data: respnose?.data,
          })
        )
      })
      .catch(error => {
        dispatch(
          providerInAction.setItems({
            loading: false,
            error: error?.response,
            data: [],
          })
        )
        console.log(error)
      })
  }

// Update Provided Receipt Status
export const updateProvidedReceiptStatus = (id, st) => dispatch => {
  dispatch(
    providerInAction.setProvidedStatus({
      loading: true,
      error: null,
      data: null,
    })
  )
  axiosInstance
    .post(`/v1/update-provided-receipt-status/${id}/${st}`)
    .then(response => {
      SAlert({
        title: "Success",
        text: `Provider to Provider Receipt ${st} Successfully`,
      })
      dispatch(getProviderIns())
      dispatch(
        providerInAction.setProvidedStatus({
          loading: false,
          error: null,
          data: response?.data,
        })
      )
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      dispatch(
        providerInAction.setProvidedStatus({
          loading: false,
          error: error?.response?.message,
          data: null,
        })
      )
    })
}

// Get receipts list for modal
export const getReceiptsList = id => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .get(`/v1/get-provider-receipts-list/${id}`)
    .then(response => {
      dispatch(providerInAction.setReceiptsList(response.data))
      dispatch(providerInAction.setLoading(false))
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      console.log(error)
    })
}

// Get receipt fields for modal form
export const getReceiptFields = id => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .get(`/v1/get-receipt-fields/${id}`)
    .then(response => {
      dispatch(providerInAction.setReceiptFields(response.data))
      dispatch(providerInAction.setLoading(false))
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      console.log(error)
    })
}

// Store provider out data from receipts list modal
export const storeProviderOutFromReceipts = data => dispatch => {
  dispatch(providerInAction.setLoading(true))
  fileaxiosInstance
    .post("/v1/store-provider-out-from-receipts", data)
    .then(response => {
      dispatch(providerInAction.setLoading(false))
      dispatch(getProviderIns())
      SAlert({
        title: "Success",
        text: "Receipt accepted and provider out created successfully",
      })
      return response
    })
    .catch(error => {
      dispatch(providerInAction.setLoading(false))
      if (error?.response?.data?.error) {
        SAlert({
          title: "Error",
          text: error.response.data.error,
          status: "error",
        })
      } else {
        SAlert({
          title: "Error",
          text: "Failed to process request",
          status: "error",
        })
      }
      throw error
    })
}
